/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/rows.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { rowsModule } from "../../../grids/grid_core/views/m_rows_view";
import gridCore from "../m_core";
export const RowsView = rowsModule.views.rowsView;
gridCore.registerModule("rows", rowsModule);